import { gql } from 'react-apollo'
const verifyCouponCodeQuery = gql`
  query verifyCouponCode($code: String!, $eventId: MongoID!) {
    verifyCouponCode(code: $code, eventId: $eventId) {
      _id
      code
      couponCodeType {
        _id
        name {
          en
          th
        }
        productTypeIds
        masterIds
        discount
        accessOverride
      }
    }
  }
`
export default verifyCouponCodeQuery



// WEBPACK FOOTER //
// ./src/App/graphql/queries/verifyCouponCode.js